import { Button, ButtonProps } from "antd";
import { UserRole } from "components/Login";
import { useHasRole } from "hooks/useHasRole";
import React from "react";

interface AuthzButtonProps extends ButtonProps {
  roles: UserRole | UserRole[] | "all";
  disabledProps?: boolean;
}

export const AuthzButton: React.FC<AuthzButtonProps> = ({
  roles,
  disabledProps,
  children,
  ...otherProps
}) => {
  const hasRole = useHasRole(roles);

  return (
    <Button disabled={!hasRole || disabledProps} {...otherProps}>
      {children}
    </Button>
  );
};
